import { render, staticRenderFns } from "./HonorariosFiduciariosV1.vue?vue&type=template&id=4c7f69fa&scoped=true"
import script from "./HonorariosFiduciariosV1.vue?vue&type=script&lang=js"
export * from "./HonorariosFiduciariosV1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7f69fa",
  null
  
)

export default component.exports